import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { SignDocumentInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useViewer } from '#imports'
import { useSelectedLanguage } from '~/composables/use-selected-language'

export function useProgramSignDocumentMutation() {
    const query = useRpQuery()
    const selectedLanguage = useSelectedLanguage()
    const activeFacility = useActiveFacility()
    const viewer = useViewer()

    return useMutation({
        mutationFn: (mutationData: SignDocumentInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation ProgramSignDocumentMutation(
                        $input: SignDocumentInput!
                        $facilityId: ID!
                        $language: Language!
                        $capacityResultFilter: CapacityResultFilter!
                        $bookingStatusFilter: BookingStatusAvailableFilter!
                        $bookingPeriodFilter: BookingPeriodFilter!
                    ) {
                        signDocument(input: $input) {
                            __typename
                            ... on SignDocumentResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseProgramContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    path
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id,
                    language: selectedLanguage.value,
                    capacityResultFilter: {
                        ignoreContractId: mutationData.id
                    },
                    bookingStatusFilter: {
                        customerId: viewer.value?.customerId ?? null
                    },
                    bookingPeriodFilter: {
                        customerId: viewer.value?.customerId ?? null
                    }
                }
            )
    })
}
